import { ErrorMessage } from "../../enums/error-message";
import { ValidationError } from "../validation-error";
export class PascalCaseValidator {
    validate(messageToTest) {
        if (typeof messageToTest !== 'string' ||
            messageToTest.indexOf('-') !== -1 ||
            messageToTest.indexOf('_') !== -1 ||
            messageToTest.charAt(0).toUpperCase() !== messageToTest.charAt(0)) {
            throw new ValidationError(ErrorMessage.INVALID_PASCAL_CASE);
        }
    }
}
